import { WebPageJsonLd } from "next-seo";
import { addBaseUrl } from "~/modules/app/seo/addBaseUrl";
import { Routes } from "~/routes";

// // // //

export function getNetworkPageDescription(): string {
    return `Explore comprehensive insights on RWA Networks, including market cap, supply metrics, issuance volumes, and more.`;
}

// // // //

/**
 * Renders WebPage SEO metadata for the Network List page using the `ArticleJsonLd` component from `next-seo`.
 *
 * @param {Object} props - The component props.
 * @param {Article} props.network - The Network data used to generate SEO metadata.
 */
export function NetworkListWebPageSEO() {
    // Get yesterday's date
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const isoYesterday = yesterday.toISOString();

    return (
        <WebPageJsonLd
            id={addBaseUrl(Routes.networks)}
            description={getNetworkPageDescription()}
            lastReviewed={isoYesterday}
            reviewedBy={{
                type: "Organization",
                name: "RWA.xyz",
            }}
        />
    );
}
